import { createHighlightComponent } from 'instantsearch-ui-components';
import { createElement, Fragment } from 'preact';
export var InternalHighlight = createHighlightComponent({
  createElement: createElement,
  Fragment: Fragment
});